import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    PLATFORM_ID,
    ViewChild,
} from '@angular/core';
import { CmsService } from '../../../services/cms.service';
import { Store } from '../../../store';
import KeenSlider from 'keen-slider';
import { iif, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-product-details-pattern-slider',
    templateUrl: './product-details-pattern-slider.component.html',
    styleUrls: ['./product-details-pattern-slider.component.scss'],
})
export class ProductDetailsPatternSliderComponent implements OnDestroy, AfterViewInit {
    @Input() images;
    @Input() loop = false;
    @Input() border = 6;
    @Input() arrowColour = '#263847';
    @Input() height = 250;
    @Input() spacing = 15;
    @Input() slidesPerView = 4;
    @Input() showDots = true;
    @Input() showNav = true;

    @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;

    currentSlide = 1;
    lastSlide: number;
    dotHelper: Array<number> = [];
    slider: any = null;
    innerWidth$ = this.store.select<number>('innerWidth');
    private isBrowser: boolean;

    constructor(private store: Store, @Inject(PLATFORM_ID) platformId: {}) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngAfterViewInit(): void {
        iif(
            () => this.isBrowser,
            new Observable((observer) => {
                this.slider = new KeenSlider(this.sliderRef.nativeElement, {
                    slidesPerView: this.slidesPerView,
                    spacing: this.spacing,
                    loop: this.loop,
                    slideChanged: (s) => {
                        this.currentSlide = s.details().relativeSlide;
                    },
                });

                if (this.slider.details().size) {
                    const dots = this.slider.details().size - this.slidesPerView + 1;
                    this.dotHelper = dots < 0 ? [] : [...Array(dots)];
                    this.lastSlide = this.slider.details().size - 1;
                } else {
                    this.dotHelper = [];
                }
                observer.next();
                observer.complete();
            })
        ).subscribe();
    }

    ngOnDestroy(): void {
        if (this.slider) {
            this.slider.destroy();
        }
    }

    slidePrev() {
        if (this.currentSlide !== 0) {
            this.currentSlide--;
            this.slider.prev();
        }
    }

    slideNext() {
        if (this.currentSlide !== this.lastSlide) {
            this.currentSlide++;
            this.slider.next();
        }
    }
}
